class FirebaseSM {
  constructor(config) {
    const defaultConfig = {
      apiKey: "AIzaSyAnCVCQ8WRkdQjwMMV-jGvliCiKq29EbiE",
      authDomain: "remomov2.firebaseapp.com",
      projectId: "remomov2",
      databaseURL: "https://remomov2.firebaseio.com",
      storageBucket: "remomov2.appspot.com",
      messagingSenderId: "421814643462",
    };
    const { initializeApp } = require("firebase/app");
    const { getAuth } = require("firebase/auth");
    const { getFirestore } = require("firebase/firestore");
    const { getDatabase } = require("firebase/database");
    const firebaseApp = initializeApp(config || defaultConfig);
    this.auth = getAuth(firebaseApp);
    this.fsdb = getFirestore();
    this.rtdb = getDatabase();
  }

  ///////// Auth //////////////////////

  async signInFB(email, password) {
    const { signInWithEmailAndPassword } = require("firebase/auth");
    try {
      const userCredential = await signInWithEmailAndPassword(
        this.auth,
        email,
        password
      );
      const user = userCredential.user;
      console.log("logged in FB user:", user.uid);
      return user;
    } catch {
      (err) => console.log("log in error", err);
      return null;
    }
  }

  signOutFB() {
    const { signOut } = require("firebase/auth");
    signOut(this.auth).then(() => console.log("signed out FB"));
  }
  get onAuthStateChanged() {
    const { onAuthStateChanged } = require("firebase/auth");
    return onAuthStateChanged;
  }

  authChange(login, logout) {
    const { onAuthStateChanged } = require("firebase/auth");
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        login();
      } else {
        logout();
      }
    });
  }
  ///////// original database finctions //////////////////////
  get onValue() {
    const { onValue } = require("firebase/database");
    return onValue;
  }
  get ref() {
    const { ref } = require("firebase/database");
    return ref;
  }
  ///////// database ////////////////////////
  async getDb(childPath) {
    const { ref, child, get } = require("firebase/database");
    const dbRef = ref(this.rtdb, childPath);
    const snapshot = await get(dbRef);
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      return { result: "fail" };
    }
  }
  async setDb(childPath, setObj) {
    if (childPath === "/" || !childPath) {
      return "fail";
    } else {
      const { ref, set } = require("firebase/database");
      const dbRef = ref(this.rtdb, childPath);
      await set(dbRef, setObj);
    }
  }
  ///////// general check //////////////////////

  checkFB() {
    const { getDatabase, ref, onValue } = require("firebase/database");
    const testRef = ref(getDatabase(), "admin/check");
    onValue(testRef, (snapshot) => {
      const data = snapshot.val();
      console.log(data);
    });
  }
  async checkFS() {
    const { getFirestore, doc, getDoc } = require("firebase/firestore");
    const testRef = doc(getFirestore(), "admin/test/subcol", "aaa");
    const docSnap = await getDoc(testRef);
    if (docSnap.exists()) {
      console.log("Firestore Document test:", docSnap.data());
    } else {
      console.log("No such firestore document!");
    }
  }
  ///////// original firestore finctions //////////////////////
  get doc() {
    const { doc } = require("firebase/firestore");
    return doc;
  }
  get getDoc() {
    const { getDoc } = require("firebase/firestore");
    return getDoc;
  }
  get collection() {
    const { collection } = require("firebase/firestore");
    return collection;
  }
  get onSnapshot() {
    const { onSnapshot } = require("firebase/firestore");
    return onSnapshot;
  }
  get writeBatch() {
    const { writeBatch } = require("firebase/firestore");
    return writeBatch;
  }

  get arrayUnion() {
    const { arrayUnion } = require("firebase/firestore");
    return arrayUnion;
  }
  get arrayRemove() {
    const { arrayRemove } = require("firebase/firestore");
    return arrayRemove;
  }
  get deleteField() {
    const { deleteField } = require("firebase/firestore");
    return deleteField;
  }

  ////////////firestore read///////////////////////////////
  async getDocFS(pathWithDocName) {
    const { doc, getDoc } = require("firebase/firestore");
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "doc_not_exist";
    } else {
      try {
        const getRef = doc(this.fsdb, obj.collectionPath, obj.docID);
        const docSnap = await getDoc(getRef);
        if (docSnap.exists()) {
          return docSnap.data();
        } else {
          return "doc_not_exist";
        }
      } catch (e) {
        return "doc_not_exist";
      }
    }
  }
  async getDocsWhereFS(
    pathEndWithCollection,
    resultType, // "array" or "object";
    whereField,
    compareOperator,
    compareVal,
    orderByField,
    order,
    qty,
    rangeField,
    upperRange,
    lowerRange
  ) {
    const {
      collection,
      query,
      where,
      getDocs,
      orderBy,
      limit,
    } = require("firebase/firestore");
    let q = query(collection(this.fsdb, pathEndWithCollection));
    if (whereField && compareOperator) {
      q = query(q, where(whereField, compareOperator, compareVal));
    }
    if (orderByField && order) {
      q = query(q, orderBy(orderByField, order));
    }
    if (qty) {
      q = query(q, limit(qty));
    }
    if (rangeField) {
      q = query(
        q,
        where(rangeField, "<=", upperRange),
        where(rangeField, ">=", lowerRange)
      );
    }
    const querySnapshot = await getDocs(q);
    let json = {},
      array = [];
    querySnapshot.forEach((doc) => {
      const docID = doc.id;
      json[docID] = doc.data();
      array = [...array, doc.data()];
    });
    if (resultType === "object") {
      return json;
    } else {
      return array;
    }
  }
  async getManyDocs(
    collectionPath,
    dataType, //dataType: "array" or "json";
    compareField,
    operator,
    compareVal
  ) {
    const { collection, query, where, getDocs } = require("firebase/firestore");
    const q = query(
      collection(this.fsdb, collectionPath),
      where(compareField, operator, compareVal)
    );
    const querySnapshot = await getDocs(q);
    let json, array;
    querySnapshot.forEach((doc) => {
      const docID = doc.id;
      json[docID] = doc.data();
      array = [...array, doc.data()];
    });
    if (dataType === "json") {
      return json;
    } else {
      return array;
    }
  }
  /////////////////firestore write//////////////////////////////
  async updateDocFS(pathWithDocName, updateObj) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async setDocFS(pathWithDocName, setObj) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, setDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        await setDoc(ref, setObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async deleteDocFS(pathWithDocName) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, deleteDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        await deleteDoc(ref);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async multiWrite(typeArr, pathArr, docIDArr, objArr) {
    const { doc, writeBatch } = require("firebase/firestore");
    const batch = writeBatch(this.fsdb);
    typeArr.forEach((type, i) => {
      if (pathArr[i] && docIDArr[i]) {
        const ref = doc(this.fsdb, pathArr[i], docIDArr[i]);
        if (type === "set") {
          batch.set(ref, objArr[i]);
        } else if (type === "update") {
          batch.update(ref, objArr[i]);
        } else if (type === "delete") {
          batch.delete(ref);
        }
      }
    });
    await batch.commit();
  }
  async unionArrayItemFS(pathWithDocName, field, item) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, arrayUnion } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [field]: arrayUnion(item) };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async removeArrayItemFS(pathWithDocName, field, item) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, arrayRemove } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [field]: arrayRemove(item) };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async addFieldValueFS(pathWithDocName, field, fieldKey, fieldValue) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [`${field}.${fieldKey}`]: fieldValue };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  async removeFieldValueFS(pathWithDocName, field, fieldValue) {
    const obj = this.splitPath(pathWithDocName);
    if (!obj) {
      return "fail";
    } else {
      const { doc, updateDoc, deleteField } = require("firebase/firestore");
      try {
        const ref = doc(this.fsdb, obj.collectionPath, obj.docID);
        const updateObj = { [`${field}.${fieldValue}`]: deleteField() };
        await updateDoc(ref, updateObj);
        return "success";
      } catch (e) {
        return "fail";
      }
    }
  }
  //////////////////general ///////////////////////////////////////
  splitPath(pathWithDocName) {
    const i = pathWithDocName.lastIndexOf("/");
    const collectionPath = pathWithDocName.slice(0, i);
    const docID = pathWithDocName.slice(i + 1);
    if (collectionPath && docID) {
      return { collectionPath, docID };
    } else {
      return null;
    }
  }
}

module.exports = FirebaseSM;
